"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSigner = void 0;
const ethers_1 = require("ethers");
const BitSigner_1 = require("./BitSigner");
class ProviderSigner extends BitSigner_1.BitSigner {
    constructor(provider) {
        super();
        this.provider = provider;
        this.signer = new ethers_1.ethers.providers.Web3Provider(provider).getSigner();
    }
    request(method, params) {
        return this.provider.request({ method, params });
    }
    signTypedData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request('eth_signTypedData_v4', [yield this.signer.getAddress(), JSON.stringify(data)]);
        });
    }
}
exports.ProviderSigner = ProviderSigner;
//# sourceMappingURL=ProviderSigner.js.map